<template>
	<v-checkbox
		v-model="isSelected"
		:color="color"
		:dense="dense"
		:disabled="disabled"
		:indeterminate="indeterminate"
		:label="$slots.label ? undefined : label"
		:error-messages="errorMessages"
		:hide-details="hideDetails"
		:on-icon="onIcon || undefined"
		:off-icon="offIcon"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<template v-if="$slots.label" v-slot:label>
			<slot name="label" />
		</template>
	</v-checkbox>
</template>

<script>
export default {
	name: 'KCheckbox',
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			type: [String, Boolean, Number],
			default: null
		},
		color: String,
		dense: Boolean,
		disabled: Boolean,
		errorMessages: {
			type: [String, Array],
			default: undefined
		},
		hideDetails: {
			type: [Boolean, String],
			default: 'auto'
		},
		indeterminate: Boolean,
		label: String,
		offIcon: String,
		onIcon: String
	},
	computed: {
		isSelected: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit('input', newValue);
			}
		}
	}
};
</script>
